import React, { useState, useEffect, useRef } from 'react';
import MarkdownComponent from './Markdown';
import Button from 'antd/lib/button';
import { MarkdownPreviewProps } from '@uiw/react-markdown-preview';

const MarkdownParagraphWithEllipsis: React.FC<{
    content: string;
    maxHeight: string;
    style?: React.CSSProperties;
    backgroundColor: string;
    markdownProps?: Partial<MarkdownPreviewProps>;
}> = ({ content, maxHeight, style, backgroundColor, markdownProps }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showMoreButton, setShowMoreButton] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.scrollHeight;
            const viewportHeight = contentRef.current.clientHeight;

            setShowMoreButton(contentHeight > viewportHeight);
        }
    }, [content]);

    const toggleIsExpanded = () => {
        setIsExpanded((prevState) => !prevState);
    };

    return (
        <div style={{ position: 'relative' }}>
            <div ref={contentRef} style={{ maxHeight: isExpanded ? '100%' : maxHeight, overflow: 'hidden' }}>
                <MarkdownComponent source={content} style={style} {...markdownProps} />
                {showMoreButton && !isExpanded && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 40,
                            left: 0,
                            right: 0,
                            height: 50,
                            zIndex: 1,
                            background: `linear-gradient(to bottom, transparent, ${backgroundColor})`,
                        }}
                    />
                )}
            </div>
            {showMoreButton && (
                <Button type="link" onClick={toggleIsExpanded} style={{ padding: 0, marginTop: 8 }}>
                    {!isExpanded ? 'Show more' : 'Show less'}
                </Button>
            )}
        </div>
    );
};

export default MarkdownParagraphWithEllipsis;
